import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';
import {NlrSanitizeResourcePipe} from '../../../pipe/nlr-sanitize-resource-pipe';

@Component({
    selector: 'nlr-attachments-modal',
    imports: [NlrSanitizeResourcePipe],
    templateUrl: './attachments-view-modal.component.html',
    styleUrls: ['../modal.scss', './attachments-view-modal.component.scss']
})
export class AttachmentsViewModalComponent implements ModalComponent {
    modalClosed: EventEmitter<string> = new EventEmitter<string>();
    modalSize: string = 'modal-lg';
    width: string = '100%';
    height: string = '600px';
    title: string = undefined;
    type: string = undefined;
    url: string = undefined;

    close() {
        this.modalClosed.emit('close');
    }
}
